import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Typography, Grid, Snackbar, Alert } from '@mui/material';
import { useStore } from '../stores';
import DashboardLayout from '../components/layout/DashboardLayout/DashboardLayout';
import UserRegistrationForm from '../components/forms/UserRegistrationForm';
import DriversSelector from '../components/selector/DriversSelector';
import { Driver } from '../stores/UserStore';

const Users: React.FC = observer(() => {
    const { userStore } = useStore();
    const [selectedDriver, setSelectedDriver] = useState<Driver | null>(null);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [selectedRole, setSelectedRole] = useState<string>('CLIENT');

    const handleDriverSelect = (driver: Driver) => {
        setSelectedDriver(driver);
        console.log('Conductor seleccionado:', driver);
    };

    const handleRoleChange = (role: string) => {
        setSelectedRole(role);
        
        if (role !== 'DRIVER') {
            setSelectedDriver(null);
        }
    };

    const handleUserCreatedSuccess = () => {
        
        setSelectedDriver(null);
        setSelectedRole('CLIENT');
        setShowSuccessMessage(true);
        
        
        userStore.loadDrivers();
    };

    const handleCloseSnackbar = () => {
        setShowSuccessMessage(false);
    };

    return (
        <DashboardLayout>
            <Box>
                <Typography variant="h4" sx={{ mb: 3 }}>
                    Gestión de Usuarios
                </Typography>
                
                <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                    Crea nuevos usuarios del sistema. {selectedRole === 'DRIVER' ? 'Selecciona un conductor de la lista para asociar con la cuenta.' : ''}
                </Typography>
                
                <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: selectedRole === 'DRIVER' ? 6 : 6, lg: selectedRole === 'DRIVER' ? 7 : 7 }}>
                        <UserRegistrationForm 
                            selectedDriverId={selectedDriver?.id}
                            onSuccess={handleUserCreatedSuccess}
                            onRoleChange={handleRoleChange}
                        />
                    </Grid>
                    {selectedRole === 'DRIVER' && (
                        <Grid size={{ xs: 12, md: 6, lg: 5 }}>
                            <DriversSelector 
                                onDriverSelect={handleDriverSelect}
                                maxHeight={508} 
                            />
                        </Grid>
                    )}
                </Grid>
            </Box>
            
            <Snackbar 
                open={showSuccessMessage} 
                autoHideDuration={4000} 
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert 
                    onClose={handleCloseSnackbar} 
                    severity="success" 
                    variant="filled"
                >
                    Usuario creado exitosamente y asociado al conductor
                </Alert>
            </Snackbar>
        </DashboardLayout>
    );
});

export default Users;
